// extracted by mini-css-extract-plugin
module.exports =  {"loadingScreen":"_loadingScreen--2RM6x","loading":"_loading--2Xc6N"};